import { DefaultSeo } from 'next-seo';

import { useSeoConfig } from '@hooks/use-seo-config';

const Seo: React.FC = () => {
  const config = useSeoConfig();

  return <DefaultSeo {...config} />;
};

export default Seo;
